import Main from "./Main";
import Footer from "../components/section/Footer";
import Header from "../components/section/Header";

export default function Home() {
  return (
    <div className="App">
      <Header />
      <Main />
      <Footer />
    </div>
  )
}